<template>
  <div>
    <div
      class="p-0 flex flex-col items-center justify-center border-blue-200 border-solid border rounded-lg md:grid md:grid-cols-4 md:content-center"
    >
      <div
        class="flex justify-center text-indigo-600 text-lg font-normal py-5 border-b border-blue-200 border-solid w-full px-5 md:col-span-1 md:px-10 md:border-b-0"
      >
        <p>{{ title }}</p>
      </div>
      <div class="md:col-span-3 border-blue-200 border-solid md:border-l">
        <div
          v-for="(val, lib) in list"
          :key="lib"
          class="first:rounded-t-lg last:rounded-b-lg odd:bg-white text-gray-900 text-sm font-light bg-indigo-100 bg-opacity-50 py-5 md:py-0 md:h-20"
        >
          <div
            class="grid grid-cols-11 items-center justify-center md:h-20 w-full"
          >
            <p
              class="mx-5 flex flex-row gap-3 items-center"
              :class="{
                'col-span-5': isLastestEvaluationVisible,
                'col-span-7': !isLastestEvaluationVisible,
              }"
            >
                <TextToSpeech :speak="lib" :withBars="!$isMobile"></TextToSpeech>
                {{ lib }}
            </p>
            <div class="col-span-2 flex justify-center">
              <checkbox-indigo
                v-if="visibilityValue1"
                :disabled="isDisabled || isDisabledValue1"
                :value="val[libKeys[0]]"
                @input="
                  (newValue) => {
                    changeValue(1, { key: lib, value: newValue });
                  }
                "
              />
            </div>
            <div
              v-if="isLastestEvaluationVisible"
              class="col-span-2 flex justify-center"
            >
              <div v-if="visibilityLastEval && !lastestEvaluation">
                Pas d'évaluation récente
              </div>
              <checkbox-indigo
                v-if="visibilityLastEval && lastestEvaluation"
                :disabled="true"
                :value="lastestEvaluation[lib].value"
              />
            </div>
            <div class="col-span-2 flex justify-center">
              <checkbox-indigo
                v-if="visibilityValue2"
                :disabled="isDisabled"
                :value="val[libKeys[1]]"
                @input="
                  (newValue) => {
                    changeValue(2, { key: lib, value: newValue });
                  }
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxIndigo from '../Inputs/CheckboxIndigo.vue';
import TextToSpeech from '../TextToSpeech.vue';

export default {
  name: 'RomeEvaluationGrid',
  props: {
    title: String,
    list: (Array, Object),
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    libKeys: Array,
    isDisabledValue1: {
      type: Boolean,
      required: false,
      default: false,
    },
    visibilityValue1: {
      type: Boolean,
      required: false,
      default: true,
    },
    visibilityLastEval: {
      type: Boolean,
      required: false,
      default: true,
    },
    visibilityValue2: {
      type: Boolean,
      required: false,
      default: true,
    },
    lastestEvaluation: {
      type: Object,
      required: false,
      default: null,
    },
    isLastestEvaluationVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      //
    };
  },

  methods: {
    changeValue(num, infos) {
      this.$emit('changeValue' + num, infos);
    },
  },

  components: {
    TextToSpeech,
    CheckboxIndigo,
  },
};
</script>
